module.exports = __webpack_public_path__ + "img/Aria_restore_power_poster.ac0764a7.png";